import { z } from "zod";

const externalHref = z.url({ protocol: /^(https?|mailto)$/ });
const richTextSchema = z.array(
  z.union([
    z.string(),
    z.strictObject({
      text: z.string(),
      bold: z.boolean().optional(),
      italic: z.boolean().optional(),
      href: z.union([z.literal("/guide"), externalHref]).optional(),
    }),
  ]),
);
const contactSchema = z.discriminatedUnion("kind", [
  z.strictObject({
    kind: z.literal("slack"),
    label: z.string(),
    text: z.string(),
    href: z.url({ protocol: /^https$/ }),
  }),
  z.strictObject({
    kind: z.literal("email"),
    label: z.string(),
    text: z.string(),
    href: z.url({ protocol: /^mailto$/ }),
  }),
]);
export const frontpageContentSchema = z.strictObject({
  landing: z.strictObject({
    title: z.strictObject({ text: z.string(), accent: z.string() }),
    intro: z.array(richTextSchema),
    faq: z.strictObject({
      label: z.string(),
      href: z.url({ protocol: /^https$/ }),
    }),
    deadline: z.strictObject({
      label: z.string(),
      date: z.iso.date(),
      closed: z.strictObject({
        title: z.string(),
        paragraphs: z.array(richTextSchema),
      }),
      paragraphs: z.array(richTextSchema),
    }),
    sections: z.array(
      z.strictObject({
        title: z.string(),
        paragraphs: z.array(richTextSchema),
        contacts: z.array(contactSchema),
      }),
    ),
  }),
  guide: z.strictObject({
    chapters: z.array(
      z.strictObject({
        title: z.string(),
        blocks: z.array(
          z.discriminatedUnion("type", [
            z.strictObject({
              type: z.literal("paragraph"),
              content: richTextSchema,
            }),
            z.strictObject({
              type: z.literal("list"),
              items: z.array(richTextSchema),
            }),
          ]),
        ),
      }),
    ),
  }),
});
export type RichText = z.infer<typeof richTextSchema>;
export type ContactEntry = z.infer<typeof contactSchema>;

export type DeadlineContent = z.infer<
  typeof frontpageContentSchema
>["landing"]["deadline"];

export type FaqLink = z.infer<typeof frontpageContentSchema>["landing"]["faq"];
